import gql from "graphql-tag";

// fields a CommunityQuestion card needs
const QUESTION_FIELDS = `
  id
  title
  createdAt
  ratedUpKnowledgeItems {
    createdBy {
      id
    }
  }
  ratedDownKnowledgeItems {
    createdBy {
      id
    }
  }
  type {
    label
  }
  slug
  poster {
    id
    firstName
    profilePic
  }
  tags {
    id
    label
  }
  answers(where: { blocked: false }) {
    id
  }
`;

const COMMUNITY_QUESTIONS_QUERY = gql`
  query COMMUNITY_QUESTIONS_QUERY($skip: Int = 0, $first: Int) {
    questions(
      first: $first
      skip: $skip
      orderBy: "createdAt_DESC"
      where: { approved: true }
    ) {
      ${QUESTION_FIELDS}
    }
  }
`;

// The Nest's default order: most answered first (backend questionsMostAnswered)
export const MOST_ANSWERED_QUESTIONS_QUERY = gql`
  query MOST_ANSWERED_QUESTIONS_QUERY($skip: Int = 0, $first: Int) {
    questionsMostAnswered(first: $first, skip: $skip) {
      ${QUESTION_FIELDS}
    }
  }
`;

// Newest approved questions nobody has answered yet
export const WAITING_QUESTIONS_QUERY = gql`
  query WAITING_QUESTIONS_QUERY($first: Int = 3) {
    questions(
      first: $first
      orderBy: "createdAt_DESC"
      where: { approved: true, answers_none: { blocked: false } }
    ) {
      id
      slug
      title
    }
  }
`;

export default COMMUNITY_QUESTIONS_QUERY;
